//  const BASE_URL = 'https://tam-rtls-api2.azurewebsites.net'
 const BASE_URL = 'http://172.105.125.180:8090/api' // 8081 => BE for QA

//Basic Management

//Satuan/Division Management
const DIVISION_URL = BASE_URL + '/division'
const DIVISION_ADD_URL = DIVISION_URL + '/create'
const DIVISION_EDIT_URL = DIVISION_URL + '/change'
const DIVISION_BAGIAN_URL = DIVISION_URL + '/get'
const DIVISION_TIPE_URL = DIVISION_URL + '/organization/get'
const DIVISION_GET_PAGE = DIVISION_URL + '/get/page'
const DIVISION_GET_ORGANIZATION = DIVISION_URL + '/get/organization'
const GET_PHOTO_USER_URL = DIVISION_URL + '/get/photo'
const UPLOAD_PHOTO_USER_URL = DIVISION_URL + '/upload/photo'
const GET_ORGANIZATION = DIVISION_URL + '/organization/get/children'
const GET_DIVISION_TO_SELECT = DIVISION_URL + '/get-parent-division'

//Fleet
const FLEET_URL = BASE_URL + '/fleet'

//Department
const DEPARTMENT_BASE_URL = BASE_URL + '/department'
const DEPARTMENT_LIST_URL = DEPARTMENT_BASE_URL + '/list'

//Member
const MEMBER_BASE_URL = BASE_URL + '/user/member'
const MEMBER_LIST_URL = MEMBER_BASE_URL + '/get'
const MEMBER_ADD_URL = MEMBER_BASE_URL + '/create'
const MEMBER_EDIT_URL = MEMBER_BASE_URL + '/update'
const MEMBER_DELETE_URL = MEMBER_BASE_URL + '/delete'
const MEMBER_CREATE_URL = MEMBER_BASE_URL + '/insert'

//Group
const GROUP_BASE_URL = FLEET_URL + '/group'
const GROUP_LIST_URL = GROUP_BASE_URL + '/get'
const GROUP_ADD_URL = GROUP_BASE_URL + '/create'
const GROUP_EDIT_URL = GROUP_BASE_URL + '/edit'

//Sub Group
const SUB_GROUP_BASE_URL = FLEET_URL + '/sub-group'
const SUB_GROUP_LIST_URL = SUB_GROUP_BASE_URL + '/get'
const SUB_GROUP_ADD_URL = SUB_GROUP_BASE_URL + '/create'
const SUB_GROUP_EDIT_URL = SUB_GROUP_BASE_URL + '/edit'

//Type
const TYPE_BASE_URL = FLEET_URL + '/type'
const TYPE_LIST_URL = TYPE_BASE_URL + '/get'
const TYPE_ADD_URL = TYPE_BASE_URL + '/create'
const TYPE_EDIT_URL = TYPE_BASE_URL + '/edit'

//Sub Type
const SUB_TYPE_BASE_URL = FLEET_URL + '/sub-type'
const SUB_TYPE_LIST_URL = SUB_TYPE_BASE_URL + '/get'
const SUB_TYPE_ADD_URL = SUB_TYPE_BASE_URL + '/create'
const SUB_TYPE_EDIT_URL = SUB_TYPE_BASE_URL + '/edit'

//Unit
const UNIT_BASE_URL = FLEET_URL + '/unit'
const UNIT_LIST_URL = UNIT_BASE_URL + '/get'
const UNIT_ADD_URL = UNIT_BASE_URL + '/create'
const UNIT_EDIT_URL = UNIT_BASE_URL + '/edit'
const UNIT_ALERT_URL = UNIT_LIST_URL + '/alert'

//Component
const COMPONENT_UNIT_BASE_URL = FLEET_URL + '/component'
const COMPONENT_UNIT_LIST_URL = COMPONENT_UNIT_BASE_URL + '/get'
const COMPONENT_UNIT_ADD_URL = COMPONENT_UNIT_BASE_URL + '/create'
const COMPONENT_UNIT_EDIT_URL = COMPONENT_UNIT_BASE_URL + '/edit'
const COMPONENT_TREE_LIST_URL = COMPONENT_UNIT_BASE_URL + '/get-tree'
const COMPONENT_GET_CHILDREN_URL = COMPONENT_UNIT_BASE_URL + '/get/children'
const COMPONENT_NOT_CHILDREN = COMPONENT_UNIT_LIST_URL + '/not-children'

//Component Category
const COMPONENT_BASE_URL = FLEET_URL + '/component-category'
const COMPONENT_LIST_URL = COMPONENT_BASE_URL + '/get'
const COMPONENT_ADD_URL = COMPONENT_BASE_URL + '/create'
const COMPONENT_EDIT_URL = COMPONENT_BASE_URL + '/edit'

//Scheduling
const SCHEDULE_BASE_URL = BASE_URL + '/schedule'
const SCHEDULE_LIST_URL = SCHEDULE_BASE_URL + '/get'
const SCHEDULE_ALERT_URL = SCHEDULE_BASE_URL + '/maintenance-alert'
const SCHEDULE_ALERT_LIST_URL = SCHEDULE_ALERT_URL + '/get'
const SCHEDULE_APPROVE_URL = SCHEDULE_BASE_URL + '/approve'
const SCHEDULE_APPROVE_RETIRE_URL = SCHEDULE_APPROVE_URL + '/retirement'
const SCHEDULE_REJECT_URL = SCHEDULE_BASE_URL + '/reject'
const SCHEDULE_ADD_URL = SCHEDULE_BASE_URL + '/create'
const SCHEDULE_EDIT_URL = SCHEDULE_BASE_URL + '/edit'
const SCHEDULE_RETIRE_URL = SCHEDULE_ADD_URL + '/retirement'
const SCHEDULE_ACTIVITY_URL = SCHEDULE_BASE_URL + '/log'
const SCHEDULE_ACTIVITY_LIST_URL = SCHEDULE_ACTIVITY_URL + '/get'

//Location
const LOCATION_BASE_URL = BASE_URL + '/location'

//Cards
const CARDS_BASE_URL = BASE_URL + '/card'
const CARDS_LIST_URL = CARDS_BASE_URL + '/list'
const CARDS_ADD_URL  = CARDS_BASE_URL + '/input'
const CARDS_MULTI_ADD_URL = CARDS_BASE_URL + '/multiadd'

//User
const USER_URL = BASE_URL + '/user'
const USER_GET_URL = USER_URL + '/get'
const USER_CREATE_URL = USER_URL + '/insert'
const USER_EDIT_URL = USER_URL + '/update'
const USER_DELETE_URL = USER_URL + '/delete'
const LOGIN_URL = USER_URL + '/login'
const LOGOUT_URL = USER_URL + '/logout'

const PERMISSION_URL = USER_URL + '/permission'
const PERMISSION_MENU_URL = PERMISSION_URL + '/get/menu'
const PERMISSION_FUNCTION_URL = PERMISSION_URL + '/get/function'

//Dashboard
const REPORT_URL = BASE_URL + '/report'
const DASHBOARD_URL = REPORT_URL + '/dashboard'
const DASHBOARD_UNIT_URL = DASHBOARD_URL + '/unit'
const DASHBOARD_COMMANDER_URL = DASHBOARD_URL + '/commander'
const DASHBOARD_COMMANDER_MAIN_URL = DASHBOARD_COMMANDER_URL + '/main'

//Report
const REPORT_GROUP = REPORT_URL + '/group/list'
const REPORT_LIST = REPORT_URL + '/list'
const REPORT_ANGGARAN_1 = REPORT_URL + '/1'
const REPORT_ANGGARAN_2 = REPORT_URL + '/2'
const REPORT_ANGGARAN_3 = REPORT_URL + '/3'
const REPORT_ANGGARAN_4 = REPORT_URL + '/4'
const REPORT_ANGGARAN_5 = REPORT_URL + '/5'
const REPORT_ANGGARAN_6 = REPORT_URL + '/6'
const REPORT_ANGGARAN_7 = REPORT_URL + '/7'
const REPORT_ANGGARAN_8 = REPORT_URL + '/8'
const REPORT_COMPONENT_9 = REPORT_URL + '/9'
const REPORT_COMPONENT_10 = REPORT_URL + '/10'
const REPORT_COMPONENT_11 = REPORT_URL + '/11'
const REPORT_COMPONENT_12 = REPORT_URL + '/12'
const REPORT_COMPONENT_13 = REPORT_URL + '/13'
const REPORT_COMPONENT_14 = REPORT_URL + '/14'
const REPORT_TASK_15 = REPORT_URL + '/15'
const REPORT_TASK_16 = REPORT_URL + '/16'
const REPORT_TASK_17 = REPORT_URL + '/17'
const REPORT_TASK_18 = REPORT_URL + '/18'
const REPORT_TASK_19 = REPORT_URL + '/19'
const REPORT_TASK_20 = REPORT_URL + '/20'
const REPORT_TASK_21 = REPORT_URL + '/21'
const REPORT_PERSONEL_22 = REPORT_URL + '/22'
const REPORT_PERSONEL_23 = REPORT_URL + '/23'
const REPORT_PERSONEL_24 = REPORT_URL + '/24'
const REPORT_PERSONEL_25 = REPORT_URL + '/25'
const REPORT_PERSONEL_26 = REPORT_URL + '/26'
const REPORT_SATUAN_27 = REPORT_URL + '/stan'
const REPORT_SATUAN_28 = REPORT_URL + '/28'
const REPORT_SATUAN_29 = REPORT_URL + '/childiv'
const REPORT_SATUAN_30 = REPORT_URL + '/admstan'
const REPORT_SATUAN_31 = REPORT_URL + '/pmkuntstan'
const REPORT_UNIT_40 = REPORT_URL + '/40'
const REPORT_UNIT_41 = REPORT_URL + '/41'
const REPORT_UNIT_42 = REPORT_URL + '/42'
const REPORT_UNIT_43 = REPORT_URL + '/43'
const REPORT_UNIT_44 = REPORT_URL + '/44'
const REPORT_UNIT_45 = REPORT_URL + '/45'
const REPORT_UNIT_46 = REPORT_URL + '/46'
const REPORT_UNIT_47 = REPORT_URL + '/47'

//Budgeting
const BUDGET_URL = BASE_URL + '/budget'
const BUDGET_YEARLY_URL = BUDGET_URL + '/years-budget'
const BUDGET_YEARLY_COMPONENT_URL = BUDGET_YEARLY_URL + '/get-bycomponent'
const BUDGET_YEARLY_ACTIVITY_URL = BUDGET_YEARLY_URL + '/get-byactivity'
const BUDGET_YEARLY_CHILDREN_URL = BUDGET_YEARLY_URL + '/get-children'
const BUDGET_SAVE_URL = BUDGET_URL + '/save-budget'
const BUDGET_SUBMIT_URL = BUDGET_URL + '/submit-budget'
const BUDGET_RESET_URL = BUDGET_URL + '/reset'

export {
    BASE_URL,

    //Basic Management
    LOGIN_URL,
    LOGOUT_URL,

    DASHBOARD_UNIT_URL,
    DASHBOARD_COMMANDER_MAIN_URL,

    //Department Management
    DEPARTMENT_BASE_URL,
    DEPARTMENT_LIST_URL,

    //Cards Management
    CARDS_BASE_URL,
    CARDS_ADD_URL,
    CARDS_LIST_URL,
    CARDS_MULTI_ADD_URL,

    //Satuan/Division Management
    DIVISION_URL,
    DIVISION_ADD_URL,
    DIVISION_EDIT_URL,
    DIVISION_BAGIAN_URL,
    DIVISION_TIPE_URL,
    DIVISION_GET_PAGE,
    DIVISION_GET_ORGANIZATION,
    GET_PHOTO_USER_URL,
    UPLOAD_PHOTO_USER_URL,
    GET_ORGANIZATION,
    GET_DIVISION_TO_SELECT,

    //Member
    MEMBER_BASE_URL,
    MEMBER_LIST_URL,
    MEMBER_ADD_URL,
    MEMBER_EDIT_URL,
    MEMBER_DELETE_URL,
    MEMBER_CREATE_URL,

    //Fleet
    FLEET_URL,

    //Group
    GROUP_BASE_URL,
    GROUP_LIST_URL,
    GROUP_ADD_URL,
    GROUP_EDIT_URL,

    //Sub Group
    SUB_GROUP_BASE_URL,
    SUB_GROUP_LIST_URL,
    SUB_GROUP_ADD_URL,
    SUB_GROUP_EDIT_URL,

    //Type
    TYPE_BASE_URL,
    TYPE_LIST_URL,
    TYPE_ADD_URL,
    TYPE_EDIT_URL,

    //Sub Type
    SUB_TYPE_BASE_URL,
    SUB_TYPE_LIST_URL,
    SUB_TYPE_ADD_URL,
    SUB_TYPE_EDIT_URL,

    //Unit
    UNIT_LIST_URL,
    UNIT_ADD_URL,
    UNIT_EDIT_URL,
    UNIT_ALERT_URL,

    //Component
    COMPONENT_UNIT_BASE_URL,
    COMPONENT_UNIT_LIST_URL,
    COMPONENT_UNIT_ADD_URL,
    COMPONENT_UNIT_EDIT_URL,
    COMPONENT_TREE_LIST_URL,
    COMPONENT_BASE_URL,
    COMPONENT_LIST_URL,
    COMPONENT_ADD_URL,
    COMPONENT_EDIT_URL,
    COMPONENT_GET_CHILDREN_URL,
    COMPONENT_NOT_CHILDREN,

    //Scheduling
    SCHEDULE_LIST_URL,
    SCHEDULE_ALERT_LIST_URL,
    SCHEDULE_APPROVE_URL,
    SCHEDULE_APPROVE_RETIRE_URL,
    SCHEDULE_REJECT_URL,
    SCHEDULE_ADD_URL,
    SCHEDULE_EDIT_URL,
    SCHEDULE_RETIRE_URL,
    SCHEDULE_ACTIVITY_LIST_URL,

    //User
    USER_URL,
    USER_GET_URL,
    USER_CREATE_URL,
    USER_EDIT_URL,
    USER_DELETE_URL,
    PERMISSION_MENU_URL,
    PERMISSION_FUNCTION_URL,

    //Report
    REPORT_GROUP,
    REPORT_LIST,
    REPORT_ANGGARAN_1,
    REPORT_ANGGARAN_2,
    REPORT_ANGGARAN_3,
    REPORT_ANGGARAN_4,
    REPORT_ANGGARAN_5,
    REPORT_ANGGARAN_6,
    REPORT_ANGGARAN_7,
    REPORT_ANGGARAN_8,
    REPORT_COMPONENT_9,
    REPORT_COMPONENT_10,
    REPORT_COMPONENT_11,
    REPORT_COMPONENT_12,
    REPORT_COMPONENT_13,
    REPORT_COMPONENT_14,
    REPORT_TASK_15,
    REPORT_TASK_16,
    REPORT_TASK_17,
    REPORT_TASK_18,
    REPORT_TASK_19,
    REPORT_TASK_20,
    REPORT_TASK_21,
    REPORT_PERSONEL_22,
    REPORT_PERSONEL_23,
    REPORT_PERSONEL_24,
    REPORT_PERSONEL_25,
    REPORT_PERSONEL_26,
    REPORT_SATUAN_27,
    REPORT_SATUAN_28,
    REPORT_SATUAN_29,
    REPORT_SATUAN_30,
    REPORT_SATUAN_31,
    REPORT_UNIT_40,
    REPORT_UNIT_41,
    REPORT_UNIT_42,
    REPORT_UNIT_43,
    REPORT_UNIT_44,
    REPORT_UNIT_45,
    REPORT_UNIT_46,
    REPORT_UNIT_47,

    //Budgeting
    BUDGET_YEARLY_COMPONENT_URL,
    BUDGET_YEARLY_ACTIVITY_URL,
    BUDGET_YEARLY_CHILDREN_URL,
    BUDGET_SAVE_URL,
    BUDGET_SUBMIT_URL,
    BUDGET_RESET_URL,
}



// WEBPACK FOOTER //
// ./src/configurations/links.jsx